/**
 * hb-motion.js
 * Hanan Bakri: the two behaviours the interaction layer cannot express in CSS.
 *
 * 1. Image arrival. jimthompson.com fades every image over 200ms once the
 *    file has decoded. CSS cannot observe decode, so this flips `is-loaded`.
 * Chrome recede used to be behaviour 2 here. It was wired to nothing for the
 * life of the build and the measured reference does not hide its nav on
 * scroll, so it is gone; see hb-motion.css section 5 for the evidence.
 *
 * Everything else in the layer is CSS. See assets/hb-motion.css.
 *
 * Safety posture, matching hb-editorial.js:
 * - Writes `hb-mo-js` onto <html> before any hidden state can apply. The
 *   only rule in hb-motion.css that hides anything is gated on that class,
 *   so if this script is blocked or throws, no image is ever hidden.
 * - Honours live `prefers-reduced-motion` changes in both directions.
 * - Re-scans on `shopify:section:load`, so the theme editor stays correct.
 *
 * Dependency free. No globals other than `window.hbMotion`.
 */

(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  root.classList.add('hb-mo-js');

  /* ---------------------------------------------------------------- images */

  function settle(wrapper) {
    wrapper.classList.add('is-loaded');
  }

  function watchMedia(scope) {
    var wrappers = (scope || document).querySelectorAll('.hb-mo-fade');

    Array.prototype.forEach.call(wrappers, function (wrapper) {
      if (wrapper.dataset.hbMoBound === 'true') return;
      wrapper.dataset.hbMoBound = 'true';

      var media = wrapper.querySelector('img, video');

      /* No media to wait on, or it is already decoded: settle immediately. */
      if (!media || (media.complete && media.naturalWidth !== 0)) {
        settle(wrapper);
        return;
      }

      /* An image that fails must still be revealed. Never leave it hidden. */
      media.addEventListener('load', function () { settle(wrapper); }, { once: true });
      media.addEventListener('error', function () { settle(wrapper); }, { once: true });
      media.addEventListener('loadeddata', function () { settle(wrapper); }, { once: true });
    });
  }

  function settleAll() {
    var wrappers = document.querySelectorAll('.hb-mo-fade:not(.is-loaded)');
    Array.prototype.forEach.call(wrappers, settle);
  }

  /* ------------------------------------------------------------------ boot */

  function init(scope) {
    watchMedia(scope);
  }

  function refresh() {
    init(document);
  }

  if (reduceMotion) {
    var onPreferenceChange = function () {
      if (reduceMotion.matches) {
        settleAll();
      }
    };

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', onPreferenceChange);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(onPreferenceChange);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.hbMotion = { init: init, refresh: refresh };
})();
